export const PREFERRED_PAGE_LENGTH_LS_KEY = 'page-length-preference';
export const LAST_VIEWED_PURCHASER_LS_KEY = 'last-viewed-purchaser';
export const PREVIOUS_AUTH_ERROR_KEY = 'previous-auth-error';

export const SUPPORTED_LOCALES = ['en-us', 'da', 'de', 'nb', 'sv'];
export const DEFAULT_LOCALE = 'en-us';

export const ALL_SYNC_USERS_ACROSS_ALL_PAGES_COUNT = 999999;

/**
 * SERVICE ERROR CODES
 */
// Purchaser has no active subscription
export const ERROR_NO_SUBSCRIPTION_PAYWALL = '54020';
// Purchaser subscription does not grant access to Admin Analytics feature
export const ERROR_ANALYTICS_PAYWALL = '54021';
// Purchaser subscription does not have access to Insights
export const ERROR_ANALYTICS_PERMISSION_DENIED = '50017';
// Purchaser subscription has no paid seats
export const ERROR_NO_PRO_SEATS_PAYWALL = '19019';
// Sync session currently running
export const ERROR_SYNC_SESSION_CURRENTLY_RUNNING = '1000';
// Cannot start sync due to duplicate emails
export const ERROR_START_SYNC_DUPLICATE_EMAILS = '1001';
// The session has been invalidated.  Please re-login Showbie.
export const ERROR_SESSION_EXPIRED = '1024';
